module.exports = __webpack_public_path__ + "static/media/kuibishan2.b1f74d91.webp";